import { render, staticRenderFns } from "./AdminDeviceTypeDetails.vue?vue&type=template&id=3864034f&"
import script from "./AdminDeviceTypeDetails.vue?vue&type=script&lang=ts&"
export * from "./AdminDeviceTypeDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports